import { render, staticRenderFns } from "./ClientGuardianAdd.vue?vue&type=template&id=5853012b&"
import script from "./ClientGuardianAdd.vue?vue&type=script&lang=js&"
export * from "./ClientGuardianAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports